export const markdownEditorMixin = {
  data () {
    return {
      editorConfig: {
        status: false,
      }
    }
  },
}
